@if (expandedSearchCriteria?.values) {
<div class="outbound-step-from-expanded-search-content">
  <sg-text class="outbound-expanded-title no-results" color="decorative-text-01" variant="sg-p4-big-paragraph">Outbound Folder - Search Results</sg-text>
  <div class="outbound-expanded-description no-results">
    <span class="outbound-expanded-description-bold">Search by</span>
    <div class="outbound-expanded-search-criteria-container">
      <div *ngFor="let value of expandedSearchCriteria.values; let index = index">
        <sg-text color="text-secondary" variant="sg-p3-standard" class="outbound-expanded-search-criteria">
          {{expandedSearchCriteria.keys[index]}}:
          <span class="outbound-expanded-description-bold search-criteria-value" [sgTextOverflowTooltip]="value.toString()">{{value}}</span>
          @if (index < expandedSearchCriteria.values.length-1) {
          <span class="value-seperator" color="text-secondary" variant="sg-p3-standard">|</span>
          }
        </sg-text>
      </div>
    </div>
    <sg-text color="text-secondary" variant="sg-p3-standard">No files for this criteria - check typos or try refining search</sg-text>
    <sg-button
      (onClick)="clickNavigateButton('expandedSearch')"
      class="outbound-expanded-no-results-button back-to-search"
      size="medium"
      text="Refine search & try again"
      icon="youtube_searched_for"
      variant="secondary"></sg-button>
  </div>
  <sg-button
    (onClick)="clickNavigateButton('inbound')"
    class="outbound-expanded-no-results-button ghost-button"
    size="medium"
    text="Skip this and go to Inbound"
    icon="skip_next"
    variant="ghost-primary"></sg-button>
</div>
} @else {
<div class="outbound-step-from-expanded-search-content">
  <sg-text class="outbound-expanded-title" color="decorative-text-01" variant="sg-p4-big-paragraph">Outbound Folder - Search Results</sg-text>
  <sg-text class="outbound-expanded-description" color="text-secondary" variant="sg-p3-standard">
    Based on your search criteria, here’s a list of files that were successfully processed and sent out to the client.
    <span style="font-weight: bold">Do you see your file below?</span>
  </sg-text>
  <sg-inspector-files-table
    #inspectorTable
    [columns]="outboundColumns"
    [tableData$]="outboundTableData$"
    [fileContent$]="outboundFileContent$"
    (onClickRow)="onClickRow.emit($event)"
    (onClickDownloadFile)="onClickDownloadFile.emit($event)">
    <div id="file-details-container" class="file-details-container">
      <sg-text variant="sg-p2" color="text-tertiary">Created from inbound file:</sg-text>
      @if (inspectorTable.selectedFile?.originalFileName) {
      <sg-text variant="sg-p2" color="text-primary" [sgTextOverflowTooltip]="inspectorTable.selectedFile?.originalFileName">
        {{inspectorTable.selectedFile?.originalFileName}}
      </sg-text>
      }
    </div>
  </sg-inspector-files-table>
  <div class="outbound-expanded-buttons-container">
    <div class="outbound-expanded-top-line-button">
      <sg-button
        (onClick)="clickNavigateButton('expandedSearch')"
        class="ghost-button"
        size="medium"
        text="Refine search"
        icon="arrow_back"
        iconPosition="start"
        variant="ghost-secondary"></sg-button>
    </div>
    <div class="outbound-expanded-bottom-line-buttons">
      <sg-button (onClick)="onClickClose.emit()" size="medium" text="Found it! Close investigation" icon="sg-check-filled" variant="secondary"></sg-button>
      <sg-button
        (onClick)="clickNavigateButton('inbound')"
        size="medium"
        text="No, let's look at Inbound"
        icon="sg-arrow-right-filled"
        variant="primary"></sg-button>
    </div>
  </div>
</div>
}
